import { createApp } from "vue";
import ElementPlus from "element-plus"; //全局引入element
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.min.js";
import App from "./App.vue";
import "hover.css";
import "normalize.css"; //默认样式
import '@/styles/element-variables.scss'
import "@/styles/float-in.scss";
import router from "./router";
//引入stores暴露出的pinia的实例
import pinia from "./stores";
//引入持久化储存
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import "video.js/dist/video-js.css"; //videojs样式

pinia.use(piniaPluginPersistedstate);
//导入svg
import "@/assets/svgIcon/index.js";
import { scrollToTop } from "@/js/modal.js";
//图片预览
// import { preview } from "v-preview-image";

// 导入动画库
import 'animate.css';
import { broadcast, formatTime, initFormData } from "./symbol/index"
// 引入文件
import VueClipBoard from 'vue-clipboard2'
// 只引入需要的图标
import { ArrowRight } from '@element-plus/icons-vue'
import * as echarts from 'echarts';

const app = createApp(App);
app.config.globalProperties.$scrollToTop = scrollToTop; // 挂载全局自定义弹窗
app.config.globalProperties.$echarts = echarts;

app.provide('$broadcast', broadcast);
app.provide('$formatTime', formatTime);
app.provide('$initFormData', initFormData);
// app.use(preview);
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(pinia);
app.use(router); //注册路由
app.use(VueClipBoard)
app.component('ArrowRight', ArrowRight)
app.mount("#app");
